import gql from 'graphql-tag';

const LIST_CAMPAIGNORDERS_WITH_PACING = gql`
  query campaignOrdersWithPacing(
    $where: CampaignOrderWhereInput!
    $orderBy: CampaignOrderOrderByInput
  ) {
    campaignOrdersConnection(where: $where, orderBy: $orderBy) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          name
          startDate
          endDate
          IONumber
          type
          orgs {
            id
            name
            CPAcronym
          }
          advertiser {
            name
            id
            CPAcronym
            level
            parentOrg {
              id
              level
              name
              CPAcronym
              createdAt
            }
          }
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrdersConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default LIST_CAMPAIGNORDERS_WITH_PACING;
